export const handleDownload = async (download_url: string, name: string) => {
    const isMobile = /iPhone|iPad|Android/i.test(navigator.userAgent)
  
    if (isMobile) {
      // Öffne direkt, damit das System "Kontakte" vorschlägt
      window.location.href = download_url
    } else {
      // Für Desktop: klassischer Download
      const response = await fetch(download_url)
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    }
  }